import { Flex, FlexProps } from 'components'
import { forwardRef } from 'react'
import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'

export type Props = ScaleProps<FlexProps>

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { styleProps, rest } = useScaleProps(props)

  return <Flex ref={ref} direction="column" position="relative" {...styleProps} {...rest} />
})
